import { NoteWrapper, RiskItem, RiskLabel, SuccessPlanCard } from "components/summary/success-plan";
import { riskItems } from "components/summary/success-plan/constants";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import moment from "moment-timezone";

type CSEAssessmentSectionProps = {
  spState: SuccessPlanState;
};

const CSEAssessmentSection = ({ spState }: CSEAssessmentSectionProps) => {
  const { spData } = spState;
  const { ccseRisk, ccseRiskNote } = spData;
  const histories = spData.histories || [];

  const riskItem: RiskItem | undefined = riskItems.find((item) => item.value === ccseRisk);

  const filteredHistories = histories.filter(
    (history: any) => history.fieldName === "ccseRiskNote"
  );

  const noteHistories = filteredHistories.slice(1);
  const lastUpdatedOn =
    filteredHistories.length > 0
      ? moment(filteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  return (
    <SuccessPlanCard titleSlot="CSE Assessment">
      <RiskLabel riskItem={riskItem} />
      <NoteWrapper
        riskNote={ccseRiskNote}
        noteHistories={noteHistories}
        lastUpdatedOn={lastUpdatedOn}
      />
    </SuccessPlanCard>
  );
};

export default CSEAssessmentSection;
